import {
  getPurchaseRewardAmountForProductV2,
  ProductRewardSearchResult,
} from "@brandclub/common-ui";
import { formatMoney } from "./string";

export const sleep = (ms: number) => {
  return new Promise<never>((resolve) => setTimeout(resolve, ms));
};

const mapProductsToRewards = (products: ProductRewardSearchResult[]) => {
  return products
    .map((product) => getPurchaseRewardAmountForProductV2(product).amount)
    .filter((reward) => reward > 0);
};

export const getAllProductsRewardWithRewardsCount = (
  products: ProductRewardSearchResult[]
): [number, number] => {
  const rewards = mapProductsToRewards(products);
  const totalRewards = rewards.reduce((acc, reward) => acc + reward, 0);
  const rewardCount = rewards.length;
  return [totalRewards, rewardCount];
};

export const formatProductReward = (
  rewardAmount: number,
  numberOfRewards: number
) => {
  if (numberOfRewards > 1) {
    return `${formatMoney(rewardAmount)} in rewards`;
  }
  return `${formatMoney(rewardAmount)} reward`;
};
